import { useState, useEffect } from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

// Selettore riutilizzabile "Acconto n° / Extra n°".
// value: '' (non scelto) | 'extra1','extra2',... | stringa numerica es. '1'
export const AccontoSelector = ({ value, onChange, label = 'Riferimento acconto *', hint, compact = false, dataTestId = 'acconto-selector' }) => {
  const isExtra = String(value || '').startsWith('extra');
  const derivedMode = isExtra ? 'extra' : (value ? 'acconto' : '');
  const [mode, setMode] = useState(derivedMode);
  useEffect(() => { if (derivedMode) setMode(derivedMode); }, [derivedMode]);

  const digits = (value || '').replace(/\D/g, '');

  const handleModeChange = (m) => {
    setMode(m);
    onChange(m === 'extra' ? `extra${digits || '1'}` : (digits || '1'));
  };

  const handleNumero = (raw) => {
    const v = raw.replace(/[^0-9]/g, '');
    onChange(mode === 'extra' ? (v ? `extra${v}` : 'extra') : v);
  };

  return (
    <div className={compact ? 'flex items-center gap-2' : 'space-y-1'}>
      {!compact && <Label>{label}</Label>}
      <div className="flex items-center gap-2">
        <Select value={mode} onValueChange={handleModeChange}>
          <SelectTrigger className={compact ? 'w-[190px] bg-white' : 'w-[210px]'} data-testid={dataTestId}>
            <SelectValue placeholder="Acconto / Extra..." />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="acconto" data-testid={`${dataTestId}-opt-acconto`}>Acconto n°</SelectItem>
            <SelectItem value="extra" data-testid={`${dataTestId}-opt-extra`}>Extra n° (fuori preventivo)</SelectItem>
          </SelectContent>
        </Select>
        {mode && (
          <Input
            type="number"
            min="1"
            step="1"
            className="w-20 bg-white"
            value={digits}
            onChange={e => handleNumero(e.target.value)}
            placeholder="n°"
            data-testid={`${dataTestId}-numero`}
          />
        )}
      </div>
      {!compact && hint && <p className="text-[11px] text-slate-400">{hint}</p>}
    </div>
  );
};
